import React from "react";

import {
  formatMoney,
  formatPercent,
} from "../../../utils/formatters";

export default function CoverageSecondaryKpis({
  summary = {},
  settings,
}) {
  const currency =
    settings?.currency || "USD";

  const activeCoverageLinks = Number(
    summary?.active_coverage_links_count ?? 0
  );

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      <KpiCard
        title="Transfer Capacity"
        value={formatMoney(
          summary?.nominal_coverage_capacity,
          currency
        )}
        subtitle="Nominal active capacity"
      />

      <KpiCard
        title="Capacity Utilization"
        value={formatPercent(
          summary?.portfolio_transfer_utilization,
          1
        )}
        subtitle="Used against portfolio P95"
      />

      <KpiCard
        title="Overcapacity"
        value={formatMoney(
          summary?.total_overcapacity,
          currency
        )}
        subtitle="Capacity above scenario P95"
      />

      <KpiCard
        title="Active Coverage Links"
        value={activeCoverageLinks}
        subtitle="Active scenario-to-coverage links"
      />
    </div>
  );
}

function KpiCard({
  title,
  value,
  subtitle,
}) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <p className="text-xs font-medium text-slate-500">
        {title}
      </p>

      <p className="mt-2 text-xl font-semibold text-slate-900">
        {value}
      </p>

      {subtitle && (
        <p className="mt-1 text-xs text-slate-400">
          {subtitle}
        </p>
      )}
    </div>
  );
}